export var getRenderListData = (showFullList, data, initialItemCount) => {
  return showFullList ? data : data === null || data === void 0 ? void 0 : data.slice(0, Math.min(data.length, initialItemCount));
};